import React from 'react';

const Badge = ({ children, tone = 'default' }) => {
  return <span className={`app-badge app-badge--${tone}`}>{children}</span>;
};

export default Badge;
